<template>
  <div>
    <config-item>
      <div class="flex_box">
        <div class="label_box">按钮类型</div>
        <el-select
          style="flex-grow: 1; width: unset"
          size="mini"
          v-model="mode.value.type"
          placeholder="请选择"
          @change="changeSelect"
        >
          <el-option
            v-for="item in groupList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </config-item>
    <config-item v-if="mode.value.type == '2'">
      <div>
        <div class="mt10 flex_box">
          <div class="mr10">
            <component
              :is="typeToComponent['upload']"
              v-model="mode.value.popupDetalis.image"
            ></component>
          </div>
          <div>
            <component
              :is="typeToComponent['string']"
              v-model="mode.value.popupDetalis.label"
              v-bind="{ label: '描述' }"
            ></component>
          </div>
        </div>
      </div>
    </config-item>
    <config-item>
      <div class="flex_box">
        <div class="label_box">操作项内容</div>
        <el-button type="primary" size="mini" @click="dialogVisible = true"
          >配置</el-button
        >
      </div>
    </config-item>
    <config-item>
      <div class="button_group">
        <div class="card_box" v-for="(item, index) in mode.value.groupList" :key="index">
          <div class="flex_box">
            <span class="f14 w80">{{ item.name }}</span>
            <i
              @click="delList(item, index)"
              style="cursor: pointer"
              class="el-icon-delete"
            ></i>
          </div>
          <div class="mt10 flex_box">
            <div class="mr10">
              <component :is="typeToComponent['upload']" v-model="item.image"></component>
            </div>
            <div>
              <component
                :is="typeToComponent['string']"
                v-model="item.label"
                v-bind="{ label: '描述' }"
              ></component>

              <component
                v-if="item.add"
                :is="typeToComponent['jump']"
                v-model="item.jump"
                v-bind="{ label: '链接' }"
              ></component>

              <div v-else class="flex_box p10 radio_box">
                <div class="f-grey f13 w90">是否展示弹窗</div>
                <el-radio-group v-model="item.isPopup">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div v-if="item.isPopup" class="flex_box pb10">
            <span class="f-grey f13 w80">弹窗内容</span>
            <el-input size="small" style="width: 205px" v-model="item.popupContent" />
          </div>
        </div>
        <p v-if="mode.value.groupList.length <= 0" class="text-center">暂无操作项</p>
      </div>
    </config-item>
    <config-item>
      <div class="flex_box">
        <div class="add_button" @click="addItem">
          <i class="el-icon-plus" style="color: #1684fc"></i>
          <span class="ml10">添加操作项</span>
        </div>
      </div>
    </config-item>
    <el-dialog
      v-if="dialogVisible"
      append-to-body
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :show-close="false"
    >
      <ul v-for="(item, index) in dataList" :key="index">
        <p class="name">{{ item.name }}</p>
        <li class="li_box" v-for="(item2, index2) in item.list" :key="'a' + index2">
          <el-checkbox
            :label="item2.nameGroup ? item2.nameGroup : item2.name"
            @change="(e) => changeName(e, item2)"
            :checked="
              mode.value.groupList.findIndex((item3) => item3.value == item2.value) > -1
            "
          ></el-checkbox>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import typeToComponent from "@/config/schema-template";
import {
  datasourceMapperPage,
  getDatasourceList,
  getDatasourceByDsId,
} from "@/api/easyApp";

export default {
  name: "SamplerButtonGroup",
  mixins: [schemaMixin],
  inject: ["mode"],
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      },
    },
    schema: {
      type: Object,
      default: () => {},
    },
    button_group: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      typeToComponent,
      dialogVisible: false,
      selectList: [],
      configContentList: [],
      othetList: [
        {
          add: false,
          type: "noUrl",
          name: "分享",
          value: "fenxiang",
          label: "分享",
          isPopup: false,
          popupContent: "",
          image: "",
          list: "",
          url: "",
          params: "",
          method: "",
          code: "fenxiang",
        },
        {
          add: false,
          type: "noUrl",
          name: "复制链接",
          value: "fuzhilianjie",
          label: "复制链接",
          isPopup: false,
          popupContent: "",
          image: "",
          list: "",
          url: "",
          params: "",
          method: "",
          code: "fuzhilianjie",
        },
        {
          add: false,
          type: "noUrl",
          name: "转发",
          value: "zhuanfa",
          label: "转发",
          isPopup: false,
          popupContent: "",
          image: "",
          list: "",
          url: "",
          params: "",
          method: "",
          code: "zhuanfa",
        },
      ],
      dataList: [
        {
          name: "管理",
          list: [],
        },
      ],
      groupList: [
        {
          label: "按钮组",
          value: "1",
        },
        {
          label: "下拉按钮",
          value: "2",
        },
      ],
    };
  },

  async mounted() {
    this.configContentList = [];
    if (this.dataSource.businessGroup) {
      let data = {
        businessGroup: this.dataSource.businessGroup,
        current: 1,
        size: 100,
      };
      let res = await datasourceMapperPage(data);
      let arr = res.data.records.filter((item) => item.name.includes("_"));
      if (arr.length > 0) {
        this.dataList[0].list = [];
        this.dataList[0].list = [...this.dataList[0].list, ...this.othetList];
        arr.forEach((item) => {
          let configContent = JSON.parse(item.configContent);
          getDatasourceByDsId(item.dsId).then((res) => {
            if (res.code == 0) {
              if (configContent.passStrategy && configContent.passStrategy.length > 0) {
                this.configContentList = configContent.passStrategy.map((item, index) => {
                  return {
                    add: false,
                    nameGroup: item.nameGroup,
                    name: item.name,
                    value: index + res.data.code,
                    label: item.name,
                    isPopup: false,
                    popupContent: "",
                    image: "",
                    list: item.list,
                    url: res.data.url,
                    params: res.data.params,
                    method: res.data.method,
                    code: res.data.code,
                  };
                });

                configContent.passStrategy.forEach((item) => {
                  if (item.nameGroup != "") {
                    let index = this.dataList[0].list.findIndex(
                      (item2) => item2.nameGroup == item.nameGroup
                    );
                    if (index == -1) {
                      this.dataList[0].list.push({
                        add: false,
                        nameGroup: item.nameGroup,
                        name: item.name,
                        value: index + res.data.code,
                        label: item.name,
                        isPopup: false,
                        popupContent: "",
                        image: "",
                        list: item.list,
                        url: res.data.url,
                        params: res.data.params,
                        method: res.data.method,
                        code: res.data.code,
                      });
                    }
                  } else {
                    this.dataList[0].list.push({
                      add: false,
                      value: index + res.data.code,
                      name: item.name,
                      label: item.name,
                      isPopup: false,
                      popupContent: "",
                      image: "",
                      list: item.list,
                      url: res.data.url,
                      params: res.data.params,
                      method: res.data.method,
                      code: res.data.code,
                    });
                  }
                });
              } else {
                this.dataList[0].list.push({
                  add: false,
                  name: res.data.name,
                  value: res.data.code,
                  label: res.data.name,
                  isPopup: false,
                  popupContent: "",
                  image: "",
                  url: res.data.url,
                  params: res.data.params,
                  method: res.data.method,
                  code: res.data.code,
                });
              }
            }
          });
        });
      }
    }
  },

  methods: {
    handleClose() {},

    changeSelect() {
      this.mode.value.popupDetalis = {
        label: "",
        image: "",
      };
      this.$forceUpdate();
    },

    addItem() {
      this.mode.value.groupList.push({
        add: true,
        name: "按钮",
        value: "20",
        label: "描述",
        image: "",
        isPopup: false,
        popupContent: "",
        jump: {
          type: "",
          data: {},
          id: "",
          linkPoint: null,
          initParams: [],
        },
      });
      this.$forceUpdate();
    },

    changeName(e, obj) {
      if (e) {
        if (obj.nameGroup && obj.nameGroup != "") {
          this.configContentList.forEach((item) => {
            if (item.nameGroup == obj.nameGroup) {
              this.mode.value.groupList.push(item);
            }
          });
        } else {
          this.mode.value.groupList.push(obj);
        }
      } else {
        if (obj.nameGroup && obj.nameGroup != "") {
          this.mode.value.groupList = this.mode.value.groupList.filter(
            (item) => item.nameGroup != obj.nameGroup
          );
        } else {
          this.mode.value.groupList = this.mode.value.groupList.filter(
            (item2) => item2.name != obj.name
          );
        }
      }
      this.$forceUpdate();
    },

    delList(item, index) {
      if (item.nameGroup && item.nameGroup != "") {
        let name = item.nameGroup;
        this.mode.value.groupList = this.mode.value.groupList.filter(
          (item2) => item2.nameGroup != name
        );
      } else {
        this.mode.value.groupList.splice(index, 1);
      }
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.flex_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.label_box {
  font-size: 14px;
  width: 95px;
  color: #969799;
  margin-right: 10px;
}

.add_button {
  cursor: pointer;
  width: 100%;
  height: 38px;
  line-height: 38px;
  color: rgba(22, 132, 252, 1);
  font-size: 16px;
  text-align: center;
  border: 1px solid rgba(22, 132, 252, 1);
}
.button_group {
  background-color: rgba(224, 224, 224, 0.21);
  padding: 10px 10px 10px 10px;
  .card_box {
    padding: 16px 12px 0px 12px;
    margin-bottom: 10px;
    border-radius: 2px;
    background-color: rgba(255, 255, 255, 1);
  }
  .card_box:last-child {
    margin-bottom: 0;
  }
}
.name {
  height: 25px;
  line-height: 25px;
  color: rgba(16, 16, 16, 1);
  font-size: 18px;
  position: relative;
  padding-left: 15px;
  &::before {
    content: "";
    position: absolute;
    width: 4px;
    height: 70%;
    left: 0px;
    top: 3px;
    background: #409eff;
    border-radius: 4px;
  }
}
.li_box {
  display: inline-block;
  width: 25%;
  padding: 20px;
}
::v-deep .el-dialog__body {
  padding-top: 0px;
}
::v-deep .upload {
  width: 70px !important;
  height: 70px !important;
}
::v-deep .label {
  display: flex;
  width: 40px !important;
  padding-top: unset !important;
  align-items: center;
}
::v-deep .jump_label {
  width: 40px !important;
}
</style>
